<template>
  <div class="socials" :class="properClass">
    <a
      href="https://www.facebook.com/"
      class="social social--facebook"
      target="_blank"
      rel="noopener noreferrer"
    >facebook</a>
    <a
      href="https://www.instagram.com/"
      class="social social--instagram"
      target="_blank"
      rel="noopener noreferrer"
    >instagram</a>
    <img
      v-if="icon === 'arrow'"
      src="../assets/img/arrow-left-dark.svg"
      class="social__arrow"
      alt
      title="Zamknij kontakt"
      @click="closePanel"
    />
    <img
      v-else-if="icon === 'hand'"
      src="../assets/img/open-hand-black.svg"
      alt
      @click="closePanel"
    />
    <img v-else src="../assets/img/meta-decor.svg" alt />
  </div>
</template>

<script>
import { bus } from "../main";

export default {
  name: "SocialMedia",
  props: {
    icon: String,
    isContactPanelActive: Boolean
  },
  methods: {
    closePanel: function() {
      bus.$emit("contactPanelHandler");
    }
  },
  computed: {
    properClass: function() {
      let output = "";
      if (this.icon === "arrow") {
        output += "socials--arrow";
      }

      if (this.icon === "hand") {
        output += "socials--hand";
      }
      if (this.isContactPanelActive) {
        output += " fadeout-desktop";
      } else {
        output += " fadein-desktop";
      }
      return output;
    }
  }
};
</script>

<style lang="scss">
.socials {
  display: flex;
  align-items: center;
  margin-top: 30px;

  .social {
    margin-left: 55px;

    &:hover {
      text-decoration: underline;
    }

    &--facebook {
      margin-left: 33px;
    }

    &__arrow {
      cursor: pointer;

      &:hover {
        transform: rotate(30deg);
      }
    }
  }

  img {
    display: block;
    margin-left: auto;
  }

  &--arrow,
  &--hand {
    .social {
      margin: 0;
    }
  }
}
</style>